import { APIModel, APIModelImpl } from '../../../toolkit/uicomponentapimodel';
import { TransactionHistoryDtoImpl } from '../../../../core/dto/transactionhistory/transactionhistorydto';
import { TransactionHistoryResponse } from '../../../../core/api/myaccount/transactionhistory/transactionhistoryresponse';
import { TransactionHistoryRequestImpl } from '../../../../core/api/myaccount/transactionhistory/transactionhistoryrequest';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';


export interface TransactionHistoryAPIModel extends APIModel
{
    getTransactionHistory(): void;
}

export class TransactionHistoryAPIModelImpl extends APIModelImpl implements TransactionHistoryAPIModel
{
    getTransactionHistory(): void 
    {
        let transactionHistoryDto = new TransactionHistoryDtoImpl();
        transactionHistoryDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
        transactionHistoryDto.setFromDate(this.getPreviousDate(30));
        transactionHistoryDto.setToDate(this.getCurrentDate());


        console.log("Current Date() =-------",transactionHistoryDto.getToDate());
        console.log("Previous Date() ------",this.getPreviousDate(30));
        this.getAPIProcesssorFactory().getMyAccountProcessorFactory()
        .getTransactionHistoryDetails()
        .success((transactionHistoryResponse: TransactionHistoryResponse)=>
        {
            console.log("Feature -------",transactionHistoryResponse.getAPIFeature());

            this.getAPIModelHandler().onSuccess(transactionHistoryResponse.getAPIFeature(), 
            transactionHistoryResponse.getDescription(), 
            transactionHistoryResponse.getTransactionHistoryDtos());
          
         })
        .failure((transactionHistoryResponse: TransactionHistoryResponse)=>
         {
           this.getAPIModelHandler().onFailure(transactionHistoryResponse.getAPIFeature(), 
           transactionHistoryResponse.getDescription(), undefined);
         })
        .execute(new TransactionHistoryRequestImpl(transactionHistoryDto));
    }


    getCurrentDate():string
    {
        let currentDate = new Date();
        let dd = currentDate.getDate().toString();
        let mm = (currentDate.getMonth()+1).toString();
        let yyyy = currentDate.getFullYear().toString();
       
        if(currentDate.getDate()<10) 
        {
            dd ='0'+dd;
        } 

        if(currentDate.getMonth()<10) 
        {
          mm='0'+mm;
        } 
        let today =dd+'-'+mm+'-'+yyyy;
        console.log("the current date: ---",today);
        return today;        
    }

    getPreviousDate(days:number):string
    {
        let date = new Date();
        let last = new Date(date.getTime() - (days * 24 * 60 * 60 * 1000));
        let day = last.getDate().toString();
        let month = (last.getMonth()+1).toString();
        let year = last.getFullYear();
        if(last.getDate()<10)
        {
            day = this.getContext().getResources().getString(Strings.zero)+day;
        }
        if(last.getMonth()<10)
        {
            month = this.getContext().getResources().getString(Strings.zero)+month;
        }
       
        let pastDate = day+"-"+month+"-"+year;

        console.log("past date :",pastDate);
        return pastDate;
    }
}


 


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/transactionhistory/transactionhistoryapimodel.tsx